// removed by extract-text-webpack-plugin
module.exports = {"gamePostersContainer":"_3-PcJyyzLck_wSbEbYnmsV","openBetSlipContainer":"_36eTOzO6Z9AA1ffKYA3Jcr","imageBannerContainer":"_3243F5EPfRjSzKZ5gxu33t","imageBanner":"wISlIgGHfHu1L_A63FyWQ"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/gamePosters.css
// module id = 883
// module chunks = 0